export enum DOCUMENT_STATE {
	NotView = 0,
	View = 1,
}
